export function dateToLocal(dateString): Date {
    var substring = dateString.toString().substring(0, 19);
    var year = parseInt(substring.substring(0,4));
    var month = parseInt(substring.substring(5,7)) - 1;
    var day = parseInt(substring.substring(8,10));
    var hour = parseInt(substring.substring(11,13) === "" ? 0 : substring.substring(11,13));
    var minute = parseInt(substring.substring(14,16) === "" ? 0 : substring.substring(14,16));
    var second = parseInt(substring.substring(17) === "" ? 0 : substring.substring(17));
    return new Date(Date.UTC(year, month, day, hour, minute, second));
}

export function dateToUTC(dateString: Date): string {
    return dateString.toUTCString();
}

export const formatShortDate = (month, year) => {
    let date = new Date(year, month, 1)
    return date.toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
    });
}

export const handleChange = (event, model, setModel) => {
    let name = event.target.name;
    let value = event.target.value !== "" ? event.target.value : undefined;

    if (event.target.type === "checkbox") {
        name = event.target.id;
        value = event.target.checked
    }
    setModel({
        ...model,
        [name]: value
    })
}

export const handleError = (apiError) => {
    try{
        var errorBody = JSON.parse(apiError.body)
        var errors = errorBody.errors
        var errorString;
        if(errors) {
            errorString = Object.keys(errors).map(errorKey => {
                return errors[errorKey].join('\n');
            }).join('\n')
        } else {
            errorString = errorBody.message;
        }
        alert(errorString)
    }
    catch{
        alert(apiError.message)
    }
}

export const handleErrorToast = (apiError) => {
    try{
        var errorBody = JSON.parse(apiError.body)
        var errors = errorBody.errors
        var errorString;
        if(errors) {
            errorString = Object.keys(errors).map(errorKey => {
                return errors[errorKey].join('\n');
            }).join('\n')
        } else {
            errorString = errorBody?.body?.message ?? errorBody?.body?.Message ?? errorBody?.message;
        }
        return errorString;
    }
    catch{
        return apiError?.body?.message ?? apiError?.body?.Message ?? errorBody?.message;
    }
}

export const formatMoney = (money) => {
    //this will allow us to change formatting if we need foreign currency.
    var formatter = new Intl.NumberFormat('en-US', {// undefined uses system locale
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(money);
}

export function storeData(title: string, data: any) {
    sessionStorage.setItem(title, JSON.stringify(data));
}

export function retrieveData(title: string): any {
    let dataString = sessionStorage.getItem(title);
    return dataString ? JSON.parse(dataString) : null;
}

export function removeData(title: string) {
    sessionStorage.removeItem(title);
}

export function isAdmin(): boolean {
    return retrieveData("token") !== null;
}

export const isProd = () => {
    const env = process.env.REACT_APP_ENV_NAME?.toLowerCase();
    return env === "production";
}

export const canAcceptCC = (paymentInfo) => {
    return (paymentInfo.cc?.allowPayment && (
        paymentInfo.cc.acceptAmex
        || paymentInfo.cc.acceptDiscover
        || paymentInfo.cc.acceptMasterCard
        || paymentInfo.cc.acceptVisa
    )) ?? false
}
export const canAcceptAch = (paymentInfo) => {
    return paymentInfo.ach?.allowPayment
}
export const canAcceptAnything = (paymentInfo) => {
    return canAcceptAch(paymentInfo) || canAcceptCC(paymentInfo)
}

export function checkExpirationDate(expMonth, expYear) {
    const today = new Date();
    if (expYear.toString().length === 2) {
        if (today.getFullYear() > (expYear + 2000)) {
            return "Expired";
        }

        else if (today.getFullYear() === (expYear + 2000) && today.getMonth()+1 > expMonth) {
            return "Expired";
        }

        else if (today.getFullYear() === (expYear + 2000) && today.getMonth()+1 === expMonth) {
            return "Expiring";
        }
        
        else {
            return "Good"
        };

    }

    else {
        if (today.getFullYear() > expYear) {
            return "Expired";
        }

        else if (today.getFullYear() === expYear && today.getMonth()+1 > expMonth) {
            return "Expired";
        }

        else if (today.getFullYear() === expYear && today.getMonth()+1 === expMonth) {
            return "Expiring";
        }
    
        else {
            return "Good"
        };
    }
}

export function checkPaymentAmount(amount, paymentMode, ccMaxAmount, ccMinAmount, achMaxAmount, achMinAmount, setHasError, setErrorMessage) {
    if (!amount || amount <= 0) {
        setHasError(true)
        setErrorMessage("Amount must be greater than zero")
    }
    else if (paymentMode === "CC") {
        if (amount > ccMaxAmount) {
            setHasError(true)
            setErrorMessage(`Credit card payment cannot be more than ${formatMoney(ccMaxAmount)}`)
        }
        else if (amount < ccMinAmount) {
            setHasError(true)
            setErrorMessage(`Credit card payment cannot be less than ${formatMoney(ccMinAmount)}`)
        }
        else {
            setHasError(false)
            setErrorMessage(null)
        }
    }
    else if (paymentMode === "ACH") {
        if (amount > achMaxAmount) {
            setHasError(true)
            setErrorMessage(`ACH payment cannot be more than ${formatMoney(achMaxAmount)}`)
        }
        else if (amount < achMinAmount) {
            setHasError(true)
            setErrorMessage(`ACH payment cannot be less than ${formatMoney(achMinAmount)}`)
        }
        else {
            setHasError(false)
            setErrorMessage(null)
        }
    }
    else {
        setHasError(false)
        setErrorMessage(null)
    }
}

export function formatDateForOffset(dateString: any, offsetInMinutes: number): string {
    if (!dateString) return '-';
    var substring = dateString.toString().substring(0, 19);
    var year = parseInt(substring.substring(0,4));
    var month = parseInt(substring.substring(5,7)) - 1;
    var day = parseInt(substring.substring(8,10));
    var hour = parseInt(substring.substring(11,13) === "" ? 0 : substring.substring(11,13));
    var minute = parseInt(substring.substring(14,16) === "" ? 0 : substring.substring(14,16));
    var second = parseInt(substring.substring(17) === "" ? 0 : substring.substring(17));
    const utcDate = new Date(Date.UTC(year, month, day, hour, minute, second));

    const adjusted = new Date(utcDate.getTime() + offsetInMinutes * 60000);
    return adjusted.toLocaleString('en-US', { timeZone: 'UTC' });
}

export function convertDateClientToOperatorUTC(dateInput: string | Date, operatorOffsetInMinutes: number): string | null {
    if (!dateInput) return null;
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return null;

    // Subtract the operator's offset to get UTC
    const utcTime = new Date(date.getTime() - operatorOffsetInMinutes * 60000);
    return utcTime.toISOString();
}

export function convertModelDatesToUTCFromOperator(model: any, operatorOffsetInMinutes: number): any {
    if (!model) return model;
    const dateFields = [
        'paymentDateFrom','paymentDateTo',
        'postingDateFrom','postingDateTo',
        'fundingDateFrom','fundingDateTo',
        'startDate','endDate',
        'paymentDate','postingDate','fundingDate','returnDate'
    ];
    const cloned = { ...model };
    dateFields.forEach(field => {
        if (cloned[field]) {
            const converted = convertDateClientToOperatorUTC(cloned[field], operatorOffsetInMinutes);
            if (converted) cloned[field] = converted;
        }
    });
    return cloned;
}